var map = {
	"./Ahmedabad.jpg": 733,
	"./Bangalore.jpg": 2140,
	"./Chennai.jpg": 6255,
	"./Delhi.jpg": 6373,
	"./Hyderabad.jpg": 8627,
	"./Kolkata.jpg": 6840,
	"./Mumbai.jpg": 5318,
	"./Pune.jpg": 9925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7099;